module.exports = __webpack_public_path__ + "static/media/dog-wolf.4ad1f971.png";